/**
 * PII scrubbing pipeline.
 * Applies regex-based scrubbing first, then NER-based scrubbing.
 * All data must pass through this pipeline before leaving the SDK.
 */

import { regexScrub } from './regex-scrubber';
import { nerScrub } from './ner-scrubber';

/**
 * Scrub all PII from a string.
 * Pipeline: text -> regex scrub (email, phone, SSN, card, IP) -> NER scrub (names, addresses)
 */
export function scrubPII(text: string): string {
  if (!text) return text;
  const afterRegex = regexScrub(text);
  const afterNER = nerScrub(afterRegex);
  return afterNER;
}

/**
 * Deep-scrub all string values in an object.
 * Recursively traverses the object and scrubs every string value.
 */
export function scrubObject<T>(obj: T): T {
  if (obj === null || obj === undefined) return obj;

  if (typeof obj === 'string') {
    return scrubPII(obj) as T;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => scrubObject(item)) as T;
  }

  if (typeof obj === 'object') {
    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(obj as Record<string, unknown>)) {
      result[scrubPII(key)] = scrubObject(value);
    }
    return result as T;
  }

  return obj;
}
